/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth >= 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

/**
 * 指定の要素のテキストを1文字ずつspanで囲む
 */
const wrapSpan = () => {
  const textWrap = document.querySelectorAll('.js-wrapSpan');
  textWrap.forEach((t) => (t.innerHTML = t.textContent.replace(/\S/g, '<span>$&</span>')));
};

/**
 * アンカーリンク
 */
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    const offset = jQuery(hash).offset().top;
    // const scrollto = offset - (("fixed" !== jQuery("#header").css("position")) ? (headerHeight + 20) : 0);
    const scrollto = offset - headerHeight;
    jQuery('html, body').animate(
      {
        scrollTop: scrollto,
      },
      500
    );
  }
}

// /**
//  * ローディング画面
//  */
// function stopload() {
//   jQuery('#js-loading').delay(900).fadeOut(800);
// }

/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;
  // wrapSpan();
  // setTimeout('stopload()', 10000);
});

/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth; // スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});

// ローディング判定
jQuery(window).on('load', function () {
  jQuery('body').attr('data-loading', 'true');
  // stopload();
});

/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

jQuery(function () {
  scrollHash();
  // gsap.to('body', { opacity: 1, duration: 0.5 });

  // 画面遷移
  window.addEventListener('beforeunload', function (e) {
    document.body.classList.add('fadeOut');
    setTimeout(() => {
      window.location = url;
    }, 500);
  });

  // スクロール判定
  jQuery(window).on('scroll', function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery('body').attr('data-scroll', 'true');
    } else {
      jQuery('body').attr('data-scroll', 'false');
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery('body').attr('data-scroll-bottom', 'true');
    } else {
      jQuery('body').attr('data-scroll-bottom', 'false');
    }

    /**
     * トップに戻るボタン
     */
    const totop = jQuery('.js-totop');
    const totopTarget = jQuery(`.${totop.data('target')}`);
    const footer = jQuery('.l-footer');
    const defaultBottom = 20; // SP時のデフォルト位置（rem換算しない）

    // スクロール位置に応じて表示切り替え
    if ((totopTarget.length ? totopTarget.innerHeight() : headerHeight) < scrollTop) {
      totop.addClass('is-active');
    } else {
      totop.removeClass('is-active');
    }

    // フッターと重ならないようにbottom位置を調整
    // const footerTop = footer.offset().top;
    // const totopHeight = totop.outerHeight();
    // const scrollBottom = scrollTop + windowHeight;

    // if (scrollBottom > footerTop) {
    //   const overlap = scrollBottom - footerTop;
    //   totop.css('bottom', defaultBottom + overlap + 'px');
    // } else {
    //   totop.css('bottom', defaultBottom + 'px');
    // }
  });

  /* ドロワー */
  jQuery('.js-drawer').on('click', function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr('aria-controls');
    const addClass = 'is-opened';

    if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
      jQuery(`#${ariaControls}`).removeClass(addClass);
    } else {
      jQuery(`#${ariaControls}`).addClass(addClass);
    }

    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr('aria-expanded', jQuery(`#${ariaControls}`).hasClass(addClass) ? 'false' : 'true');
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        jQuery(this).addClass(addClass);
      } else {
        jQuery(this).removeClass(addClass);
      }
    });

    // ドロワー開時にbody要素がスクロールしないように
    jQuery(`#${ariaControls}`).hasClass(addClass)
      ? jQuery('body').addClass('u-overflowHidden')
      : jQuery('body').removeClass('u-overflowHidden');

    // ドロワー開閉時のヘッダー位置調整
    const header = document.querySelector('.js-header');
    const drawerContent = document.querySelector('.p-drawer__content');

    if (header && drawerContent) {
      if (jQuery(`#${ariaControls}`).hasClass(addClass)) {
        // ドロワー開時：ヘッダーを固定位置に設定
        header.style.position = 'fixed';
        header.style.top = '0';
        header.style.left = '0';
        header.style.right = '0';
        header.style.zIndex = '9999';

        // bodyのmargin-topで翻訳バーの有無を判定してドロワーコンテンツのmargin-topを調整
        const bodyMarginTop = window.getComputedStyle(document.body).marginTop;
        const marginTopValue = parseFloat(bodyMarginTop);

        if (marginTopValue >= 56) {
          // 翻訳バーが表示されている場合
          drawerContent.style.marginTop = '56px';
        } else {
          // 翻訳バーが非表示の場合
          drawerContent.style.marginTop = '0px';
        }
      } else {
        // ドロワー閉時：ヘッダーのスタイルをリセット
        header.style.position = '';
        header.style.top = '';
        header.style.left = '';
        header.style.right = '';
        header.style.zIndex = '';

        // ドロワーコンテンツのmargin-topもリセット
        drawerContent.style.marginTop = '';
      }
    }

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#drawer-content1 a[href*="#"]').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop('href');
    const hrefUrl = href.split('#')[0]; // リンク先のURL

    if (currentUrl == hrefUrl) {
      jQuery('.for-drawer').removeClass('is-opened');
      jQuery('#drawer-content1').attr('aria-hidden', true);
      jQuery('body').removeClass('u-overflowHidden');
    }
  });

  /* ヘッダ */
  jQuery(window).on('load scroll', function () {
    // if (jQuery('body').hasClass('home')) {
    const $header = jQuery('.js-header');
    if ($header.length) {
      const target = jQuery(`.${jQuery($header).data('target')}`);
      const targetHeight = target.length ? target.innerHeight() : headerHeight * 1.1;
      let position = jQuery(this).scrollTop();
      if (position > targetHeight) {
        $header.addClass('is-fixed');
      } else if (position == 0) {
        $header.removeClass('is-fixed');
      }
    }
    // }
  });

  /* スムーススクロール */
  jQuery(document).on(
    'click',
    'a[href*="#"]:not(".js-tabIndex, .js-modal, .js-accordion, .toc_toggle a")',
    function (e) {
      const currentUrl = location.protocol + '//' + location.host + location.pathname.replace(/\/$/, ''); // 現在のURL
      const href = jQuery(this).prop('href');
      const hrefUrl = href.split('#')[0].replace(/\/$/, ''); // リンク先のURL
      // let target = $(this.hash);
      // if (!target.length) return;

      if (currentUrl == hrefUrl) {
        e.preventDefault();
        let id = '#' + href.split('#')[1]; // リンク先のアンカー
        let speed = 500;
        let target = jQuery('#' == id ? 'html' : id);
        let position = target.offset().top - headerHeight;
        if ('fixed' !== jQuery('#header').css('position') && 'sticky' !== jQuery('#header').css('position')) {
          position = target.offset().top;
        }
        if (0 > position) {
          position = 0;
        }
        jQuery('html, body').animate(
          {
            scrollTop: position,
          },
          speed,
          'swing'
        );
        jQuery(this).blur();
        // return false;
      }
    }
  );

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf('iPhone') < 0 && $ua.indexOf('Android') < 0) {
    // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css('cursor', 'default') // カーソルをポインターにしない
      .css('pointer-events', 'none') // ホバーなども動作しない
      .on('click', function (e) {
        e.preventDefault();
      });
  }

  /* tab */
  jQuery('.js-tabIndex').on('click', function (e) {
    e.preventDefault();
    const tabParent = jQuery(this).parents('.js-tab');
    const targets = jQuery(this).data('target');
    const target = jQuery(this).attr('href');

    jQuery('.js-tabIndex.is-active').removeClass('is-active');
    jQuery(this).addClass('is-active');

    // 現在表示しているものを非表示にする
    tabParent.find(`.${targets}.is-active`).removeClass('is-active');
    // クリックしたタブのターゲットを表示
    jQuery(target).addClass('is-active');

    return false;
  });
});

// ヘッダーのドロップダウンメニュー (修正版：ドロップダウンが複数になったことにより、要素ごとにタイマーを管理)
jQuery(function ($) {
  const $item = $('.p-header__item--has-child');
  const delay = 150; // 閉じるまでの遅延時間 (ミリ秒)

  $item.on('mouseenter', function () {
    const $this = $(this);
    // この要素に設定されているタイマーIDを取得
    let hideTimer = $this.data('hideTimer');

    // 閉じるためのタイマーが設定されていたら即座にキャンセルする
    if (hideTimer) {
      clearTimeout(hideTimer);
      $this.removeData('hideTimer'); // タイマーIDを削除
    }

    // 即座に開くクラスを追加
    $this.addClass('is-open');
  });

  $item.on('mouseleave', function () {
    const $this = $(this);

    // 古いタイマーが残っている可能性があるため、念のためクリア
    let oldTimer = $this.data('hideTimer');
    if (oldTimer) {
      clearTimeout(oldTimer);
      $this.removeData('hideTimer');
    }

    // 閉じる処理を遅延させるタイマーを設定し、タイマーIDをこの要素に保存
    let newTimer = setTimeout(() => {
      $this.removeClass('is-open');
      $this.removeData('hideTimer'); // 処理実行後、タイマーIDを削除
    }, delay);

    $this.data('hideTimer', newTimer); // 新しいタイマーIDを要素に保存
  });
});

// Serviceスライダー
document.addEventListener('DOMContentLoaded', function () {
  let mySwiper = new Swiper('#js-service-slider', {
    // 以下にオプションを設定
    loop: true, //最後に達したら先頭に戻る

    speed: 5000, //スライドするスピード
    slidesPerView: 'auto', //コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    spaceBetween: 34, //スライド間の余白
    allowTouchMove: false, // ユーザー操作を無効化
    // centeredSlides: true, //スライドを中央寄せ

    //自動再生
    autoplay: {
      delay: 0, // 自動再生の間隔（ミリ秒）
      disableOnInteraction: false, //ユーザー側で操作してもスライドを止めない
    },
  });
});

// Staffスライダーとインタビュー用モーダル
document.addEventListener('DOMContentLoaded', () => {
  let staffSwiper = null; // ← 最初に1回だけ let で宣言

  // スタッフスライダーの初期化関数
  function initStaffSwiper() {
    // 既存のSwiperを破棄
    if (staffSwiper) {
      staffSwiper.destroy(true, true);
      staffSwiper = null;
    }

    // SP用スタッフスライダー
    if (window.matchMedia('(max-width: 767px)').matches) {
      const spSlider = document.querySelector('#js-staff-slider-sp');
      if (spSlider) {
        staffSwiper = new Swiper('#js-staff-slider-sp', {
          // 以下にオプションを設定
          loop: true, // 最後に達したら先頭に戻る
          speed: 500, // スライドするスピード
          slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
          spaceBetween: 40,
          watchSlidesProgress: true,
          observer: true, // 変更を監視
          observeParents: true, // 親要素の変更も監視
          navigation: {
            prevEl: '.p-top__staff-sp-prev-button',
            nextEl: '.p-top__staff-sp-next-button',
          },
        });
      }
    } else {
      // PC用スタッフスライダー
      const pcSlider = document.querySelector('#js-staff-slider');
      if (pcSlider) {
        staffSwiper = new Swiper('#js-staff-slider', {
          // 以下にオプションを設定
          loop: true, // 最後に達したら先頭に戻る
          speed: 500, // スライドするスピード
          slidesPerView: 6.5, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
          slidesPerGroup: 1,
          spaceBetween: 10, // スライド間の余白
          navigation: {
            prevEl: '.p-top__staff-prev-button',
            nextEl: '.p-top__staff-next-button',
          },
          // 自動再生
          // autoplay: {
          //   delay: 2000, // 自動再生の間隔（ミリ秒）
          // },
        });
      }
    }

    // Swiper初期化後に1回実行しておく
    if (staffSwiper) {
      staffSwiper.on('afterInit', function () {
        this.emit('slideChangeTransitionEnd');
      });
    }
  }

  // 初期化実行
  initStaffSwiper();

  // リサイズ時の再初期化
  window.addEventListener('resize', () => {
    initStaffSwiper();
  });

  // モーダル + インタビュー用Swiper
  let interviewSwiper = null;
  let activeIndex = 0;

  // ナビゲーション更新関数
  function updateNav(swiper) {
    const realSlides = [
      ...document.querySelectorAll('.js-interview-slider .swiper-slide:not(.swiper-slide-duplicate)'),
    ];
    const total = realSlides.length;
    const current = swiper.realIndex;

    // 前と次のインデックスをループ考慮で取得
    const prevIndex = (current - 1 + total) % total;
    const nextIndex = (current + 1) % total;

    const $prevBtn = document.querySelector('.js-custom-prev .p-modal__interview-nav-inner');
    const $nextBtn = document.querySelector('.js-custom-next .p-modal__interview-nav-inner');

    // 前ナビ
    const prevSlide = realSlides[prevIndex];
    if (prevSlide) {
      const nav = prevSlide.querySelector('.js-nav-data')?.innerHTML;
      if (nav) {
        $prevBtn.innerHTML = nav;
        $prevBtn.closest('button').style.display = 'flex';
      } else {
        $prevBtn.innerHTML = '';
        $prevBtn.closest('button').style.display = 'none';
      }
    }

    // 次ナビ
    const nextSlide = realSlides[nextIndex];
    if (nextSlide) {
      const nav = nextSlide.querySelector('.js-nav-data')?.innerHTML;
      if (nav) {
        $nextBtn.innerHTML = nav;
        $nextBtn.closest('button').style.display = 'flex';
      } else {
        $nextBtn.innerHTML = '';
        $nextBtn.closest('button').style.display = 'none';
      }
    }
  }

  // カスタムナビクリック処理
  function bindCustomNav() {
    document.querySelector('.js-custom-prev')?.addEventListener('click', () => {
      interviewSwiper?.slidePrev();
    });
    document.querySelector('.js-custom-next')?.addEventListener('click', () => {
      interviewSwiper?.slideNext();
    });
  }

  // Micromodal 初期化
  setTimeout(() => {
    MicroModal.init({
      disableScroll: false,
      disableFocus: true,
      onShow: () => {
        document.body.classList.add('is-modal-open');
      },
      onClose: () => {
        document.body.classList.remove('is-modal-open');
        if (interviewSwiper) {
          interviewSwiper.destroy(true, true);
          interviewSwiper = null;
        }
      },
    });
  }, 100);

  // オーバーレイクリックでモーダルを閉じる
  setTimeout(() => {
    document.querySelector('.js-interview-modal-overlay')?.addEventListener('click', () => {
      MicroModal.close('modal-interview');
    });
  }, 100);

  // スライドクリックでモーダル表示
  document.querySelectorAll('.js-open-interview').forEach((el) => {
    el.addEventListener('click', (e) => {
      // ここでactive判定を追加
      if (!el.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
        // activeでなければ何もしない
        e.preventDefault();
        return;
      }
      const number = el.dataset.interviewNumber;
      const slides = document.querySelectorAll('.js-interview-slider .swiper-slide');

      // 対応スライドのインデックスを特定
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].dataset.interviewNumber === number) {
          activeIndex = i;
          break;
        }
      }

      // Swiper 初期化前にモーダル本体を非表示状態でDOMに出す
      const modal = document.getElementById('modal-interview');
      modal.style.display = 'block';
      modal.style.visibility = 'hidden'; // まだ見せない
      modal.style.pointerEvents = 'none';

      // Swiper 初期化
      if (interviewSwiper) {
        interviewSwiper.destroy(true, true);
      }

      interviewSwiper = new Swiper('.js-interview-slider', {
        loop: true,
        initialSlide: activeIndex,
        autoHeight: true, //各スライドの高さに合わせて自動調整
        navigation: {
          nextEl: '.js-interview-next',
          prevEl: '.js-interview-prev',
        },
        on: {
          init: updateNav,
          slideChange: updateNav,
        },
      });

      bindCustomNav();

      // 初期化後にモーダルを Micromodal 経由で表示
      // ※ setTimeout不要、確実な順序で表示される
      MicroModal.show('modal-interview');

      // 表示を戻す
      modal.style.visibility = '';
      modal.style.pointerEvents = '';
    });
  });
});

// お問い合わせフォームの送信ボタンを押したらサンクスページに遷移
document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    window.location.href = '/contact-thanks/';
  },
  false
);

// ボディのマージントップ監視とヘッダー調整（多言語サイト対応）
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.js-header');
  const body = document.body;

  function checkBodyMarginTop() {
    if (header) {
      const bodyMarginTop = window.getComputedStyle(body).marginTop;
      const marginTopValue = parseFloat(bodyMarginTop);

      if (marginTopValue >= 56) {
        // マージントップ56px以上の場合、ヘッダーにtop値を設定
        header.style.top = bodyMarginTop;
      } else {
        // マージントップ56px未満の場合（翻訳バーがボタン化または非表示）、ヘッダーのtop値をリセット
        header.style.top = '';
      }

      // ドロワーが開いている場合、ドロワーコンテンツのmargin-topも更新
      const drawerContent = document.querySelector('.p-drawer__content');
      if (drawerContent && drawerContent.classList.contains('is-opened')) {
        // ドロワーが表示されている場合
        if (marginTopValue >= 56) {
          drawerContent.style.marginTop = '56px';
        } else {
          drawerContent.style.marginTop = '0px';
        }
      }
    }
  }

  // 初期チェック
  checkBodyMarginTop();

  // リサイズ時とスクロール時にチェック
  window.addEventListener('resize', function () {
    checkBodyMarginTop();
  });

  window.addEventListener('scroll', function () {
    checkBodyMarginTop();
  });

  // 定期的にチェック（リアルタイム性向上）
  setInterval(function () {
    checkBodyMarginTop();
  }, 100); // 100ms間隔でチェック

  // MutationObserverでDOM全体の変更を監視（翻訳バーのボタン化を検出）
  const observer = new MutationObserver(function (mutations) {
    let shouldCheck = false;

    mutations.forEach(function (mutation) {
      // bodyのstyle属性変更
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && mutation.target === body) {
        shouldCheck = true;
      }
      // DOM要素の追加・削除（翻訳バーの表示/非表示）
      if (mutation.type === 'childList') {
        shouldCheck = true;
      }
    });

    if (shouldCheck) {
      checkBodyMarginTop();
    }
  });

  // bodyのstyle属性とdocument全体のDOM変更を監視
  observer.observe(body, {
    attributes: true,
    attributeFilter: ['style'],
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
});
